import PersonalAccessTokensTable from "./PersonalAccessTokensTable";

export default PersonalAccessTokensTable;

export { PersonalAccessTokensTable };
